import { SearchOutlined } from '@ant-design/icons';
import {
    Breadcrumb,
    Button,
    Col,
    Input,
    Row,
    Space,
    Table,
    Tooltip,
    Popconfirm,
    message
} from 'antd';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { fetchArchiveDieTypeList, unArchiveDieType } from './../../slices/die-type';

export default function ArchiveDieGroup() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pagesize, setPageSize] = useState(10);

    const dispatch = useDispatch();
    const {data = [], totalRecord,  status} = useSelector(state => state.dieType || {});
    useEffect(() => {
        dispatch(
            fetchArchiveDieTypeList({ page, pagesize, ...(search && { search: search }) }),
        );
    }, [dispatch, page, pagesize, search]);

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => {
            setSelectedRowKeys(selectedKeys);
        },
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1); // Reset to the first page when searching
    };

    const resetFilter = () => {
        setSearch('');
        setPage(1);
    };

    const handlePageChange = newPage => {
        setPage(newPage);
    };
    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        setPageSize(pagination.pageSize);
    };
    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
    }));




    const handleRestore = (id) => {
        if (!id) {
            message.error('Missing ID for deletion!');
            return;
        }

        dispatch(unArchiveDieType(id))
            .unwrap()
            .then(() => {
                message.success('Die Type Unarchived Successfully!');
            })
            .catch((err) => {
                console.error('Delete Error:', err); // Debugging the error
                message.error(`Error: ${err.message || 'Failed to delete the group.'}`);
            });
    };

    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
        },
        {
            title: 'Die Type Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'action',
            render: (text, record) => (
                <Space>
                  <Link>
                    <Tooltip title="Restore">
                      <Popconfirm
                          title="Are you sure you want to Unarchive this record?"
                          onConfirm={() => handleRestore(record.id)} // Trigger delete on confirmation
                          onCancel={() => message.info('Action cancelled')} // Optional cancel action
                          okText="Yes"
                          cancelText="No"
                      >
                        <ArchiveRestore className="ArchiverestorImg" />
                      </Popconfirm>
                    </Tooltip>
                  </Link>
                </Space>
            ),
        },
    ];


  return (
    <>
      <Row className="pagenamerow" justify="space-between" align="middle">
        <Col>
          <h2 style={{ margin: 0 }}>Archive Die Types</h2>
          <div className="bredcrumbwrp">
            <Link to="/die-type" className="back">
              <Back /> BACK
            </Link>
              <Breadcrumb
                  items={[
                      { title: <Link to="/dashboard">Home</Link> },
                      { title: <Link to="/die-type">Die Types</Link> },
                      { title: 'Archive Die Types' }
                  ]}
              />
          </div>
        </Col>
        <Col>
          <Space>
            <Input
              placeholder="Search"
                  className='searchbox'
              prefix={<SearchOutlined />}
              value={search}
              style={{ width: 200 }}
              onChange={handleSearch}
            />
              <Link>
                  <Tooltip placement="top" title={'Reset Filter'}>
                      <Button type="primary" disabled={!search} className='iconlink' onClick={resetFilter}>
                          <FilterIcon />
                      </Button>
                  </Tooltip>
              </Link>
          </Space>
        </Col>
      </Row>

      <Table
        rowSelection={rowSelection}
        dataSource={dataSource}
        columns={columns}
        loading={status === 'loading'}
        pagination={{
            current: page, // Update the current page based on state
            pageSize: pagesize,
            total: totalRecord,
            showSizeChanger: true,
            onChange: handlePageChange, // Update page when changed
        }}
        onChange={handleTableChange}
        style={{ marginTop: '20px' }}
      />
    </>
  );
}
